(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller(
			'lobConfiguration',
			lobConfiguration
		);

	lobConfiguration.$inject = [];

	function lobConfiguration() {
		var vm = this;
	}
})();
